import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import { AppShell } from "@/components/layout/AppShell";

import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Dashboard from "@/pages/Dashboard";
import BusinessProfile from "@/pages/BusinessProfile";
import Assessment from "@/pages/Assessment";
import BusinessMap from "@/pages/BusinessMap";
import DigitalMaturity from "@/pages/DigitalMaturity";
import AIReadiness from "@/pages/AIReadiness";
import OpportunityRadar from "@/pages/OpportunityRadar";
import Roadmap from "@/pages/Roadmap";
import Reports from "@/pages/Reports";

function FullScreenLoader() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <div className="flex flex-col items-center gap-3">
        <div className="h-8 w-8 animate-spin rounded-full border-2 border-muted border-t-accent" />
        <p className="text-sm text-muted-foreground">Preparing your workspace…</p>
      </div>
    </div>
  );
}

function Protected({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user === false) return <Navigate to="/login" replace />;
  return children;
}

function PublicOnly({ children }) {
  const { user } = useAuth();
  if (user === null) return <FullScreenLoader />;
  if (user) return <Navigate to="/app" replace />;
  return children;
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<PublicOnly><Login /></PublicOnly>} />
            <Route path="/register" element={<PublicOnly><Register /></PublicOnly>} />
            <Route path="/app" element={<Protected><AppShell /></Protected>}>
              <Route index element={<Dashboard />} />
              <Route path="profile" element={<BusinessProfile />} />
              <Route path="assessment" element={<Assessment />} />
              <Route path="business-map" element={<BusinessMap />} />
              <Route path="maturity" element={<DigitalMaturity />} />
              <Route path="ai-readiness" element={<AIReadiness />} />
              <Route path="opportunities" element={<OpportunityRadar />} />
              <Route path="roadmap" element={<Roadmap />} />
              <Route path="reports" element={<Reports />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
